module.exports = __webpack_public_path__ + "img/03-thumb.c94c8d1c.png";